<template>
  <div class="comp_list" @contextmenu.prevent="onContextMenu($event)">
    <top-list-header />
    <component-list v-show="getSidebarSection === 'Components'" />
    <asset-list v-show="getSidebarSection === 'Assets'" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import emitter from 'tiny-emitter/instance';
import { useProtect } from '@/composables/useProtect.js';
import { SYS_PERMISSIONS, EVENT } from '@/constants.js';
import TopListHeader from './TopListHeader.vue';
import ComponentList from './ComponentList.vue';
import AssetList from './AssetList.vue';
import componentTypes from '../../vuex/project/types/components-types.js';
import assetTypes from '../../vuex/project/types/assets-types.js';

export default {
  components: {
    'component-list': ComponentList,
    'asset-list': AssetList,
    'top-list-header': TopListHeader,
  },

  setup() {
    const { hasPermission: canEdit } = useProtect({
      permissions: [SYS_PERMISSIONS.SYS_PROJECTS_EDIT],
      roles: ['editor'],
    });

    return {
      canEdit,
    };
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters('application', ['getSidebarSection']),
    ...mapGetters('project/data/assets', ['getRootContainer']),
  },

  mounted() {},

  methods: {
    ...mapActions('project/data/components', ['customCreate', 'customUpdate']),
    ...mapActions('project/data/assets', ['createAsset']),
    ...mapActions('application/contextMenu', [
      'createItem',
      'setCalcPosition',
      'deleteMenu',
      'setOnDeleteMenu',
    ]),
    /**
     * Event handler for contextmenu event.
     */
    onContextMenu(event) {
      console.log('ONCONTEXTMENU');
      if (this.canEdit) {
        this.createContextMenu(event.clientX, event.clientY);
      }
    },

    /**
     * Create a context menu for this board
     * @param {Number} x  The x client coordinate
     * @param {Number} y  The y client coordinate
     */
    async createContextMenu(x, y) {
      if (this.getSidebarSection === 'Components') {
        this.createItem({
          name: 'Create Component',
          icon: null,
          commands: {
            doAction: () => {
              this.customCreate({
                component: componentTypes.newItem,
                tIndex: '-',
                apply: true,
              });
              this.deleteMenu();
            },
            isActive: () => true,
            isEnabled: () => true,
          },
          submenu: null,
        });
        this.createItem({
          name: 'Create Folder',
          icon: null,
          commands: {
            doAction: () => {
              this.customCreate({
                component: componentTypes.newContainer,
                tIndex: '-',
                apply: true,
              });
              this.deleteMenu();
            },
            isActive: () => true,
            isEnabled: () => true,
          },
        });
      } else if (this.getSidebarSection === 'Assets') {
        this.createItem({
          name: 'Upload new asset...',
          icon: null,
          commands: {
            doAction: () => {
              emitter.emit(
                EVENT.OPEN_FILE_UPLOADER,
                this.getRootContainer.id,
                false,
                false
              );
              this.deleteMenu();
            },
            isActive: () => true,
            isEnabled: () => true,
          },
        });
        this.createItem({
          name: 'Create Folder',
          icon: null,
          commands: {
            doAction: () => {
              const tId = null;
              const tIndex = '-';
              this.createAsset({
                props: assetTypes.newContainer.data,
                tId,
                tIndex,
                tExpand: true,
                apply: true,
              });
              this.deleteMenu();
            },
            isActive: () => true,
            isEnabled: () => true,
          },
        });
      }

      this.setCalcPosition({
        calcPosition: () => {
          return { left: x, top: y };
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  .comp_list {
    width: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
    flex: 1;
  }
}
</style>
